export const VENEER_APPROVAL_REQUEST = "VENEER_APPROVAL_REQUEST";
export const VENEER_APPROVAL_SUCCESS = "VENEER_APPROVAL_SUCCESS";
export const VENEER_APPROVAL_FAILED = "VENEER_APPROVAL_FAILED";
